import React, { Component } from 'react'

class AddEquipment extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: true,
      defaultName: '',
      defaultBody: '',
      name: '',
      body: ''
    }
  }

  _handleCancelClick () {
    this.setState({
      edit: false,
      name: this.state.defaultName,
      body: this.state.defaultBody
    })
    this.props.cancel()
  }

  _handleSaveClick () {
    console.log('saving data...')
    const { name, body } = this.state
    const data = {
      name,
      body
    }
    this.props.saveData(data)
    this.setState({ edit: false })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _renderEquipmentName () {
    return <textarea rows="1" type="text" value={this.state.name} onChange={this._handleUpdateContent.bind(this, 'name')}></textarea>
  }
  _renderEquipmentBody () {
    return <textarea rows="1" type="text" value={this.state.body} onChange={this._handleUpdateContent.bind(this, 'body')}></textarea>
  }

  render () {
    return (
      <article className="equipment">
        <div className="equipment_inner admin_inner flex column">
          <div className="contents flex top_label">
            <div className="equipment_label label">設備名</div>
            { this._renderEquipmentName()}
          </div>
          <div className="contents flex bottom_label">
            <div className="equipment_label label">設備説明</div>
            { this._renderEquipmentBody()}
          </div>
        </div>
        <div className="btn_group flex">
          <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>
          <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
        </div>
      </article>
    )
  }
}

export default AddEquipment



// WEBPACK FOOTER //
// ./src/components/Properties/Equipments/AddEquipment.js